export default __webpack_public_path__ + "static/media/header_logo.132b1b00.png";